class Top10Slide {
	constructor($dom, index){
		this.left = 0;
		this.total = 0;
		this.mr = 0;
		this.w = 0;
		this.len = 0;
		this.current = 0;
		this.dom = $dom;
		this.index = index;
		this.lists = $dom.querySelectorAll("ul li.list_rank");
		this.resize();
		this.nav();
	}
	resize(){
		let $this = this;
		
		$this.len 	= $this.lists.length;
		$this.w 	= $this.lists[0].clientWidth;
		$this.mr 	= $this.lists[1].offsetLeft - $this.w - $this.lists[0].offsetLeft;
		$this.total = ($this.w + $this.mr)*$this.len;
		$this.current = $this.dom.querySelector("ul").offsetLeft;
		$this.change();
		$this.checkNav();
		//console.log($this.len, $this.w, $this.mr, $this.total, $this.current)
		/*
		top10Slide.len 	= $("#thisweektop10 ul li.list_rank").length;
		top10Slide.w 	= $("#thisweektop10 ul li.list_rank").width();
		top10Slide.mr 	= $("#thisweektop10 ul li.list_rank").eq(1).offset().left - $("#thisweektop10 ul li.list_rank").width() - $("#thisweektop10 ul li.list_rank").eq(0).offset().left;
		top10Slide.total = (top10Slide.w + top10Slide.mr)*top10Slide.len;
		top10Slide.current = $("#thisweektop10 ul").offset().left;
		*/
	}
	nav(){
		let $this = this;
		let $prev = $this.dom.querySelector(".btn_slide10_prev");
		let $next = $this.dom.querySelector(".btn_slide10_next");
		//console.log($prev, $next);
		$prev.removeEventListener("click", { self: this, handleEvent: this.dec}, false);
		$prev.addEventListener("click", { self: this, handleEvent: this.dec}, false);
		
		$next.removeEventListener("click", { self: this, handleEvent: this.inc}, false);
		$next.addEventListener("click", { self: this, handleEvent: this.inc}, false);
	}
	inc(){
		let ulW;
		let $this = this.self;
		let $prev = $this.dom.querySelector(".btn_slide10_prev");
		let $next = $this.dom.querySelector(".btn_slide10_next");
		if(isSmallScreen){
			ulW = $this.dom.querySelector("li.list_rank").offsetWidth;
			//$("li.list_rank").outerWidth();
		}else{
			let listW = $this.w + $this.mr;
			let count = Math.floor( $this.dom.querySelector(".c-slide_music_header").clientWidth / listW );
			ulW = ($this.w + $this.mr)*count
			//var ulW = $("#thisweektop10 .slide_top10_header").width();
		}
		
		let rightEnd 	= $this.current + ulW;
		let diff 		= $this.total - rightEnd;
		if(diff <= ulW){
			$this.current += diff;
			if( $prev.classList.contains("disable") ){
				$prev.classList.remove("disable");
			}
			if( !$next.classList.contains("disable") ){
				$next.classList.add("disable");
			}
		}else{
			$this.current += ulW;
			if( $prev.classList.contains("disable") ){
				$prev.classList.remove("disable");
			}
			if( $next.classList.contains("disable") ){
				$next.classList.remove("disable");
			}
		}
		//console.log(ulW, diff, $this.current);
		$this.change();
	}
	dec(){
		let ulW;
		let $this = this.self;
		let $prev = $this.dom.querySelector(".btn_slide10_prev");
		let $next = $this.dom.querySelector(".btn_slide10_next");
		if(isSmallScreen){
			ulW = $this.dom.querySelector("li.list_rank").offsetWidth;
			//$("li.list_rank").outerWidth();
		}else{
			let listW = $this.w + $this.mr;
			let count = Math.floor( $this.dom.querySelector(".c-slide_music_header").clientWidth / listW );
			ulW = ($this.w + $this.mr)*count
			//var ulW = $("#thisweektop10 .slide_top10_header").width();
		}
		let rightEnd 	= $this.current + ulW;
		if($this.current < ulW){
			$this.current = 0;
			if( !$prev.classList.contains("disable") ){
				$prev.classList.add("disable");
			}
			if( $next.classList.contains("disable") ){
				$next.classList.remove("disable");
			}
		}else{
			$this.current -= ulW;
			if( $prev.classList.contains("disable") ){
				$prev.classList.remove("disable");
			}
			if( $next.classList.contains("disable") ){
				$next.classList.remove("disable");
			}
		}
		$this.change();
	}
	checkNav(){
		let $this = this;
		let $prev = $this.dom.querySelector(".btn_slide10_prev");
		let $next = $this.dom.querySelector(".btn_slide10_next");
		if( $this.current === 0){
			if( !$prev.classList.contains("disable") ){
				$prev.classList.add("disable");
			}
			if( $next.classList.contains("disable") ){
				$next.classList.remove("disable");
			}
		}
	}
	change(){
		let $this = this;
		let $target = $this.dom.querySelector(".list_ranks");
		if(isSmallScreen){
			$target.style.transform = `translate3d(0, 0, 0)`;
			//$this.dom.querySelector(".slide_top10_content").scrollLeft = $this.current + "px";
			//console.log($(".slide_top10_content").eq($this.index));
			$(".slide_top10_content").eq($this.index).animate({
				scrollLeft : $this.current + "px"
			},600);
			/**/
		}else{
			$target.style.transform = `translate3d(${-$this.current}px, 0, 0)`;
		}
		$this.checkNav();
	}
}
var top10Slide = {
	left: 0,
	total: 0,
	mr: 0,
	w: 0,
	len: 0,
	current: 0,
	arry: [],
	isActive: false,
	init: function(){
		if(!top10Slide.isActive){
			top10Slide.isActive = true;
			let $slides = document.querySelectorAll(".slide_top10");
			//console.log($slides);
			$slides.forEach( ($slide, index) => {
				top10Slide.arry[index] = new Top10Slide($slide, index);
			});
		}
		let resizeFlag;
		let resizeTimer = null;
		var resizeCallback = function() {
			top10Slide.resize();
			resizeTimer = null;
		};
		window.addEventListener("resize", function(){
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		}, false);
		
	//	console.log(top10Slide.total, top10Slide.total);
	},
	resize: function(){
		top10Slide.arry.forEach( (s, index) => {
			s.resize();
		});
	}
}